window.useOpenCFTurnstileChecked = async () => {
  return await new Promise((resolve, reject) => {
    const req = {
      detail: {
        successCallback: (token) => {
          resolve(token)
        },
        errorCallback: (code) => {
          const err = {
            message: 'Turnstile recaptcha fail',
            code: code || 0
          }
          reject(err)
        }
      }
    }
    document.dispatchEvent(new CustomEvent('useOpenCFTurnstileChecked', req))
  })
}
/**
 * @description cf 验证
 * @param {*} el
 */

const cfSitekey = '0x4AAAAAAAQ0xNN_STcUteE5'
// 测试test
// const sitekey = '1x00000000000000000000AA' // 总是成功
// const sitekey = '2x00000000000000000000AB' // 总是阻塞
// const sitekey = '1x00000000000000000000BB' // 总是过去
// const sitekey = '2x00000000000000000000BB' // 总是阻塞
// const sitekey = '3x00000000000000000000FF' // 强制互动

window.useCFTurnstileChecked = (language, cb) => {
  return new Promise((resolve, reject) => {
    const render = function () {
      cb && cb()
      window.turnstile.render('#cf-turnstile', {
        sitekey: cfSitekey,
        theme: 'light',
        size: 'normal', // compact normal
        language: language === 'zh' ? 'zh-tw' : language || 'en',
        callback: function (token) {
          resolve(token)
        },
        'error-callback': function (err) {
          reject(err)
        }
      })
    }
    if (window.turnstile) {
      render()
    } else {
      window.onloadTurnstileCallback = render
      const script = document.createElement('script')
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback'
      script.onerror = function (err) {
        reject(err)
      }
      document.body.appendChild(script)
    }
  })
}
